import { useMemo } from 'react';
import styled from 'styled-components';

import { spacing, mediumShadow } from 'ui/theme';
import { useSortingContext } from 'utils/contexts/sorting';

import { HeaderRow } from './HeaderRow';
import { ListRow } from './ListRow';
import { EmptyTableState } from './EmptyTableState';
import { SkeletonRows } from './SkeletonRows';
import { TABLE_COLUMNS_WIDTHS, ORDERED_TABLE_COLUMNS } from '../constants';
import { Table } from '../../components/table';
import { useListsContext } from '../../contexts/ListsContext';
import { sortLists } from '../sortLists';

export const TableWrapper = styled.div`
  box-shadow: ${mediumShadow.boxShadow};
  border-radius: ${spacing.half};
  overflow: hidden;
`;

const TABLE_COLUMNS = ORDERED_TABLE_COLUMNS.map((column) => ({
  id: column,
  width: TABLE_COLUMNS_WIDTHS[column],
}));

export const ListTable = () => {
  const { sortBy, sortDirection } = useSortingContext();
  const { allLists, isSubscribedToList, isLoading } = useListsContext();
  const sortedListsForUser = useMemo(() => {
    const listsForUser = allLists.filter(({ id }) => isSubscribedToList[id]);
    return sortLists(listsForUser, sortBy, sortDirection);
  }, [allLists, isSubscribedToList, sortBy, sortDirection]);

  const skeleton = <SkeletonRows lists={sortedListsForUser} isLoading={isLoading} />;
  const lists = sortedListsForUser.map((list, i) => <ListRow key={i} list={list} rowIndex={i} />);
  const hasNoContent = sortedListsForUser.length === 0;

  return (
    <TableWrapper data-test="list-table">
      <Table columns={TABLE_COLUMNS}>
        <HeaderRow />
        {isLoading ? skeleton : lists}
        {!isLoading && hasNoContent && <EmptyTableState />}
      </Table>
    </TableWrapper>
  );
};
